module.exports = __webpack_public_path__ + "img/matomo_analytics.708eb2a1.jpg";